var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00B4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9974 22.6654C20.351 22.6654 20.6902 22.5249 20.9402 22.2748C21.1903 22.0248 21.3307 21.6857 21.3307 21.332V13.332L17.3307 9.33203H11.9974C11.6438 9.33203 11.3046 9.47251 11.0546 9.72256C10.8045 9.9726 10.6641 10.3117 10.6641 10.6654V21.332C10.6641 21.6857 10.8045 22.0248 11.0546 22.2748C11.3046 22.5249 11.6438 22.6654 11.9974 22.6654H19.9974ZM16.6641 10.6654L19.9974 13.9987H16.6641V10.6654ZM12.6641 13.332H14.6641V14.6654H12.6641V13.332ZM12.6641 15.9987H19.3307V17.332H12.6641V15.9987ZM12.6641 18.6654H19.3307V19.9987H12.6641V18.6654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNotification);
export default __webpack_public_path__ + "static/media/file-notification.d006717ffb736c49332cc903e026c8c4.svg";
export { ForwardRef as ReactComponent };